import React from "react";
import FieldString from "../../string/string";
import FieldEmail_ManagementPreview from "./render/management-preview";
import FieldConfig from "../../../proto/field-config";
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups";
import FieldEmail_Editable from "./render/editable/editable";

export default class FieldEmail extends FieldString {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Email";
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Email input field"
        this.icon               = 'i5-email';

        this.components = {
            ValueIcon: <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>
        }

        this.renderComponents.managementPreview = FieldEmail_ManagementPreview

        this.renderComponents.editable          = FieldEmail_Editable
        // this.renderComponents.tableCell         = FieldEmail_TableCell

    }
}
